// Generated with AI Coding Rules Hub
import { HighlineService } from '@cof/auto-refinance-node-highline';
import * as jose from 'jose';
import { DebugService } from '../debug.service.js';
import { REFI_ESIGN_CONST } from '../../../../constants/app.constants.js';
import { ApiService } from '../../../core/services/api/api.service.js';
import { EncryptionService } from '../encryption.service.js';
import { SessionService } from '../../../core/services/session/session.service.js';
import { BORROWER_DL_NUMBER, CO_BORROWER_DL_NUMBER } from '../../../e-title/etitle.config.js';

export class _DownloadService {
  constructor() {
    this._productId = 'refiSpringbootKeys';
    this.debugService = new DebugService('DownloadService');
  }

  set productId(value) {
    this._productId = value;
  }

  async generateEphemeralKeys() {
    let keys = {};
    try {
      keys = await EncryptionService.generateKeyPairs();
    } catch (ex) {
      this.debugService.error('Failed to generate ephemeral keys', ex);
    }
    return keys;
  }

  async downloadEtitle(additionalInfo, shouldShowSignature) {
    try {
      const { privateKey, publicKey } = await this.generateEphemeralKeys();
      additionalInfo = additionalInfo.map(elem => (elem.fieldValue == null ? { fieldName: elem.fieldType, fieldValue: '' } : { fieldName: elem.fieldType, fieldValue: elem.fieldValue }));
      await this.encryptAdditionalInfo(additionalInfo);
      const response = await this.requestEtitleDownload(additionalInfo, shouldShowSignature, publicKey);
      const encryptedDoc = response.documentByteArray;
      const blob = await this.decryptFile(encryptedDoc, privateKey);
      this.generateDownloadLink(blob);
    } catch (ex) {
      this.debugService.error('Failed to download ETitle Document', ex);
      throw ex;
    }
  }

  async encryptAdditionalInfo(additionalInfo) {
    for (const info of additionalInfo) {
      if (info.fieldName === BORROWER_DL_NUMBER || info.fieldName === CO_BORROWER_DL_NUMBER) {
        await HighlineService.getPublicKey(REFI_ESIGN_CONST.PUBLIC_KEY_PRODUCT_ID);
        info.fieldValue = await HighlineService.encryptWithPublicKey(info.fieldValue);
      }
    }
  }

  async requestEtitleDownload(additionalInfo, shouldShowSignature, publicKey) {
    const requestBody = {
      fieldValues: additionalInfo,
      publicSecKey: publicKey ? JSON.stringify(await jose.exportJWK(publicKey)) : null,
      shouldShowSignature,
      documentType: 'Title',
      titleTemplateId: '',
    };
    const { eAppId } = SessionService.session;
    const encodedEAppId = encodeURIComponent(eAppId);
    const response = await ApiService.post(`${REFI_ESIGN_CONST.ESIGN_BFF_URL}/${encodedEAppId}/documents`, requestBody, {
      headers: {
        Accept: 'application/json;v=2',
      },
    });
    return response;
  }

  async decryptFile(encryptedFile, privateKey) {
    const plainText = await EncryptionService.compactDecrypt(encryptedFile, privateKey);
    const blob = new Blob([plainText.buffer], {
      type: 'octet/stream',
    });
    return blob;
  }

  generateDownloadLink(blob) {
    const anchor = document.createElement('a');
    anchor.setAttribute('style', 'display: none');
    anchor.setAttribute('download', 'REVIEW_ETITLE.pdf');
    anchor.setAttribute('href', window.URL.createObjectURL(blob));
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('referrerpolicy', 'no-referrer');
    anchor.setAttribute('type', 'application/pdf');
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
}

export const DownloadService = new _DownloadService();
